import * as DomUtils from '../../utils/dom-utils';
import {
  WINDOW_EVT_RESIZE,
  windowEventHelperModule,
} from '../../helpers/window-event-helper/window-event-helper';

export const activateOnScrollComponentModule = angular
  .module('Q.components.activate-on-scroll', [windowEventHelperModule])

  .directive('activateOnScroll', function ($window, $timeout) {
    return {
      restrict: 'A',
      link(scope, elem, attrs) {
        const scrollTargetSelector =
          attrs.scrollTarget || attrs.activateOnScroll;
        const scrollTarget = scrollTargetSelector
          ? document.querySelector(scrollTargetSelector) || $window
          : $window;
        const $scrollTarget = angular.element(scrollTarget);
        const relativeParent = attrs.relativeParent
          ? document.querySelector(attrs.relativeParent)
          : null;
        const $relativeParent = relativeParent
          ? angular.element(relativeParent)
          : null;
        const activeClass = attrs.activeClass || 'active';
        let debounceTimer;
        let scrollToScrolling = false;

        $scrollTarget.on('scroll', _onScroll);
        scope.$on('$destroy', () => $scrollTarget.off('scroll', _onScroll));
        scope.$on(WINDOW_EVT_RESIZE, _onScroll);

        scope.$on('scrollTo.scrolling', (evt, active) => {
          if (!active) {
            _activate();
          }
          scrollToScrolling = active;
        });

        $timeout(_activate, 150);

        //// private functions

        function _onScroll() {
          if (scrollToScrolling || debounceTimer) return;
          debounceTimer = $timeout(function () {
            debounceTimer = null;
            _activate();
          }, 50);
          _activate();
        }

        function _activate() {
          let found = false;
          let scrollOffset = $scrollTarget.scrollTop();
          let el;

          // allow for things like fixed headers by specifying a relative parent
          if ($relativeParent) {
            scrollOffset += $relativeParent.offsetTop();
          }

          // Now loop through children, and figure out who's the first one on screen
          // by looking for the
          const children = elem.children();
          angular.forEach(children, function (child, i) {
            child = angular.element(child);
            // always clear classes first
            child.removeClass(activeClass);
            if (found) return;

            // now determine what our target ID is (we do it here so it can be set at a later time)
            el = _getActiveElement(child);
            // the + 2 gives us a 2px buffer, because we don't want to mark the active section if we're
            // on the edge between them.  Fixes a bug in scroll-to, as well.
            if (el && el.offsetTop() > scrollOffset + 2) {
              if (i > 0) {
                let activeEl = angular.element(children[i - 1]);
                if (!activeEl.attr('disable-activate')) {
                  activeEl.addClass(activeClass);
                }
                // disabling this for now, it causes too many obscure issues.
                // the only place it's _really_ useful is the KB, and even there it's probably not critical enough
                //if(!scrollToScrolling && lastActiveEl && lastActiveEl.attr('id') && $window.history && $window.history.replaceState) {
                //	$window.history.replaceState({}, '', $window.location.href.replace(/(#.*|$)/, '#') + lastActiveEl.attr('id'));
                //}
              }
              found = true;
            }
          });
          if (!found && children.length > 0) {
            angular
              .element(children[children.length - 1])
              .addClass(activeClass);
          }
        }

        function _getActiveElement(child) {
          let activeSelector = child.attr('linkTarget');
          let activeId;
          if (!activeSelector) {
            activeId = child.attr('href') || child.attr('scroll-to');
            if (!activeId) {
              const el = child.querySelector('a');
              activeId = el.length
                ? el.attr('href') || el.attr('scroll-to')
                : '';
            }
            activeSelector = activeId && activeId.replace(/.*#/, '#');
          }
          return activeSelector
            ? angular.element(DomUtils.querySelector(activeSelector))
            : null;
        }
      },
    };
  });
